import { useQueryParamHelper } from '@shared/core/queryString';
import { PRIORITIZE_TAG_PARAM } from '@shared/constants/accommodations';

/**
 * The tag hint on the current URL, ready to write onto the next one, or `undefined` if there is none.
 *
 * Carried from search to the property page and back, because the tag is what makes a search a
 * honeymoon search: a hop that drops it returns the guest to generic results. `getValueString`
 * comma-joins a repeated key, the shape the console reads back (see `usePrioritizeTagsQueryParam`).
 */
export const usePrioritizeTagParam = (): string | undefined => {
  const queryParamHelper = useQueryParamHelper();
  return queryParamHelper.getValueString(PRIORITIZE_TAG_PARAM) || undefined;
};
